import { injectTestProjectsWithRuleImportResolution } from './ruleImportComposition';
import authContext from './modules/authorization/AuthContext';
import * as React from 'react';
import './styles/common.less';
import './styles/rules.less';
import './styles/ref-data.less';
import './styles/index.css';
import './styles/side-menu.less';
import './styles/iota.less';
import './styles/uploaded-packages.less';
import './styles/administration.less';
import './styles/labels.less';
import './styles/nestedTable.css';
import './styles/project-field-bindings.less';
import './styles/form-types.less';
import './styles/project-setting.less';
import './styles/test-projects.less';
import 'react-sortable-tree-patch-react-17/style.css';
import './tracing';
import * as Sentry from '@sentry/react';
import { Provider } from 'mobx-react';
import { Router } from 'react-router';

import AdminApp from './containers/App';

import { injectRootStores } from './modules/common/stores';
import { injectIntLabelsStores } from './modules/visual_blocks/stores';
import { injectIotaAppStores } from './modules/iota_applications/stores';
import { injectIotaConnStores } from './modules/iota_connections/stores';
import { injectIotaSessStores } from './modules/iota_sessions/stores';
import { injectListLabelsStores } from './modules/list_textblocks/stores';
import { injectMlStorageStores } from './modules/ml_models/stores';
import { injectProjectStores } from './modules/project_management/stores';
import { injectUploadStores } from './modules/upload_data/stores';
import { injectViewerStores } from './modules/viewer_base/stores';
import { injectRulesStores } from './modules/rules/stores';
import { injectAdministrationStores } from './modules/administration/stores';
import { injectReferenceDataStores } from './modules/iota_reference_data/stores';
import { injectIotaAuditStores } from './modules/iota_audit/stores';
import { injectFieldBindingsStores } from './modules/field_bindings/stores';
import { injectFormTypesStores } from './modules/form_types/stores';
import { injectHistoryStores } from './modules/history/stores';
import { injectInstructWorkflowStores } from './modules/instruct_workflows/stores';
import { injectSchemaGeneratorStores } from './modules/schema_generator/stores';
import { injectApplicationDefinitionConditionalStores } from './modules/application_definition_conditional/stores';
import { injectDataCrafterTemplatesStores } from './modules/data_crafter_templates/stores';
import { injectPromptTemplateStores } from './modules/prompt_templates/stores';
import { injectScriptManagementStores } from './modules/script_management/stores';
import { injectMongoConsoleStores } from './modules/mongo_console/stores';
import { injectWebRequestConsoleStores } from './modules/web_request_console/stores';
import { injectTrainingProjectsStores } from './modules/training_projects/stores';
// configure({ enforceActions: true });

let sentryConfig = require('./sentry.json') as Record<string, string>;

if (window.RUNTIME_CONFIG?.sentryConfig) {
    sentryConfig = {
        ...sentryConfig,
        ...(window.RUNTIME_CONFIG.sentryConfig as Record<string, string>)
    };
}

if (sentryConfig.dsn && sentryConfig.dsn !== '') {
    Sentry.init({
        dsn: sentryConfig.dsn,
        environment: sentryConfig.environment
    });
}

function init(permissions: string[]) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rootStores: any = {};

    const { history } = injectRootStores(rootStores, permissions);
    injectIntLabelsStores(rootStores);
    injectProjectStores(rootStores);
    injectUploadStores(rootStores);
    injectViewerStores(rootStores);
    injectRulesStores(rootStores);
    injectIotaAppStores(rootStores);
    injectIotaConnStores(rootStores);
    injectIotaSessStores(rootStores);
    injectListLabelsStores(rootStores);
    injectMlStorageStores(rootStores);
    injectAdministrationStores(rootStores);
    injectReferenceDataStores(rootStores);
    injectIotaAuditStores(rootStores);
    injectFieldBindingsStores(rootStores);
    injectFormTypesStores(rootStores);
    injectTestProjectsWithRuleImportResolution(rootStores);
    injectHistoryStores(rootStores);
    injectInstructWorkflowStores(rootStores);
    injectSchemaGeneratorStores(rootStores);
    injectApplicationDefinitionConditionalStores(rootStores);
    injectDataCrafterTemplatesStores(rootStores);
    injectPromptTemplateStores(rootStores);
    injectScriptManagementStores(rootStores);
    injectMongoConsoleStores(rootStores);
    injectWebRequestConsoleStores(rootStores);
    injectTrainingProjectsStores(rootStores);

    // TODO: find a better way to to keep store's state when doing hot reload
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).stores = (window as any).stores || rootStores;
    }

    return { rootStores, history };
}

class App extends React.Component {
    static contextType = authContext;
    declare context: React.ContextType<typeof authContext>;

    render() {
        console.log(`Version: ${process.env.REACT_APP_VERSION}`);
        const { rootStores, history } = init(this.context.permissions);
        return (
            <Sentry.ErrorBoundary>
                <Provider {...((window as any).stores || rootStores)}>
                    {/* ConnectedRouter will use the store from Provider automatically */}
                    <Router history={history}>
                        <AdminApp />
                    </Router>
                </Provider>
            </Sentry.ErrorBoundary>
        );
    }
}

export default App;
